import { combineReducers } from "redux";
import authReducer from "./authReducer";
import errorReducer from "./errorReducer";
import ThemeOptions from './ThemeOptions';
import * as actionTypes from './actionTypes';
import ForgotPassReducer from './ForgotPassReducer';

const initialState = {
  id:'',
  token:'',
  gmailId:'',
  facebookId:'',
  count:0,
  fcount:19,
  email:''
};



const userReducer = (state = initialState, action) =>{
  
  switch(action.type){

    case actionTypes.ADD_USER:
      return {
         ...state,
        id: action.payload.id,
        token: action.payload.token,
        gmailId: action.payload.gmailId,
        facebookId: action.payload.facebookId,
        email: action.payload.email
      }
   
      case actionTypes.LOGOUT_USER:
        return {
        ...state,
        id: '',
        token: '',
        gmailId: '',
        facebookId: '',
        email: ''
      };

      case actionTypes.UPDATE_COUNT:
         return {
        ...state,
        count: action.payload.count
      };
      case actionTypes.FINAL_COUNT:
        return {
        ...state,
        fcount: action.payload.count
      };

    default: 
      return state;

  }


}

export default combineReducers({
  auth: authReducer,
  errors: errorReducer,
  user:userReducer,
  otptime:ForgotPassReducer,
  ThemeOptions
});


